import type { IUseGetItineraryFareBreakup } from '../fareBreakupUtils';
import type { IUseItineraryFareBreakupProps } from '../../../hooks/Flights/useItineraryFareBreakup/useItineraryFareBreakup';
import type { AirPnrTravelerInfo } from '../../../types/api/v1/obt/pnr/pnr';

interface IProps {
  flightFareBreakup: IUseGetItineraryFareBreakup | null;
  tripTravelers: AirPnrTravelerInfo[];
}

export const getItineraryFareBreakupFromFlightFareBreakup = ({
  flightFareBreakup,
  tripTravelers,
}: IProps): IUseItineraryFareBreakupProps => {
  if (!flightFareBreakup || flightFareBreakup.paxesFareBreakup.length < 1 || tripTravelers.length < 1) {
    return {
      flightFareBreakup: null,
      travelers: [],
      holdBooking: false,
    };
  }

  const travelers = tripTravelers.map((tripTravelerInfo) => tripTravelerInfo.traveler);

  const { zeroMoney } = flightFareBreakup.paxesFareBreakup[0].fareComponents;

  const itineraryFareBreakup: IUseItineraryFareBreakupProps['flightFareBreakup'] = {
    ...flightFareBreakup,
    airlineFees: flightFareBreakup.merchantFee,
    allowedFop: [],
    showBrexPointsFare: false,
    zeroMoney,
    paxesFareBreakup: flightFareBreakup.paxesFareBreakup.map((paxBreakupInfo, paxIndex) => ({
      ...paxBreakupInfo,
      paxUserId: travelers[paxIndex]?.userOrgId?.userId?.id || '',
      fareComponents: {
        ...paxBreakupInfo.fareComponents,
        legBaseFare: paxBreakupInfo.fareComponents.legBaseFare || [],
      },
    })),
    totalBookingAmount: flightFareBreakup.totalAmountExcludingServiceFees,
    changeFees: zeroMoney,
    eligibleRefund: flightFareBreakup.paxesFareBreakup[0].fareComponents.eligibleRefund,
    appliedCreditAirlineCode: flightFareBreakup.paxesFareBreakup[0].fareComponents.appliedCreditAirlineCode,
  };

  return {
    flightFareBreakup: itineraryFareBreakup,
    travelers,
    holdBooking: false,
  };
};
